/**
 * Converts the given `rem` value into its equivalent in `px`.
 *
 * @param rem The `rem` value to convert into `px`.
 * @return The `px` equivalent of the given `rem` value.
 */
export function convertRemToPixels(rem: string): number {
  const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const remValue = parseFloat(rem);
  return baseFontSize * remValue;
}
